import { lazy } from 'react';
import { RouteDatum } from '../types';

const PrivacyPolicy = lazy(async () => await import('@upright/ui/common/generic/components/legal/privacy-policy'));
const SignupView = lazy(async () => await import('@upright/ui/views/login-views/signup-view'));
const LoginView = lazy(async () => await import('@upright/ui/views/login-views/login-view'));
const LoginRedirectView = lazy(
  async () => await import('@upright/ui/views/login-views/login-view/login-redirect-view'),
);
const SubscriptionTermsAndConditionsView = lazy(
  async () => await import('@upright/ui/common/activities/company-subscription/subscription-terms-and-conditions-view'),
);

/**
 * Content paths
 *
 * Sync any changes in here to a list in prepare-sitemap.ts
 */
export const contentRoutes: RouteDatum[] = [
  { path: '/signup', element: <SignupView /> },
  { path: 'login', element: <LoginView /> },
  { path: 'login-redirect', element: <LoginRedirectView /> },
  { path: '/subscription-terms-and-conditions', element: <SubscriptionTermsAndConditionsView /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
];
